import Highcharts from 'highcharts';

const dots: Record<string, Highcharts.SVGElement> = {};

interface RenderDotOpts {
  chart: Highcharts.Chart;
  point: Highcharts.Point & { plotX?: number; plotY?: number }; // https://github.com/highcharts/highcharts/issues/13738
  id: string;
  color: string;
}

export const renderDot = ({ chart, point, id, color }: RenderDotOpts) => {
  if (dots[id]) {
    dots[id].destroy();
  }

  const x = chart.plotLeft + (point.plotX || 0);
  const y = chart.plotTop + (point.plotY || 0);

  const plotY = point.plotY || 0;

  const offset = Object.values(dots).some(dot => {
    const dotX = dot.attr('cx');
    const dotY = dot.attr('cy');
    return dotX === x && dotY === y;
  })
    ? plotY === 100
      ? -10
      : 10
    : 0;

  dots[id] = chart.renderer
    .circle(x, y + offset, 5)
    .attr({
      fill: color,
      zIndex: 3,
    })
    .add();

  dots[id].element.setAttribute('aria-hidden', 'true');
};
